import React from "react";
import { AlertBadge20Filled, DocumentBulletList20Filled } from "@fluentui/react-icons";
import { card, useTextStyles } from "../styles";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  linksList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginTop: "16px"
  },
  container: { ...card, flexDirection: "column", alignItems: "start", width: "inherit" }
});

export const QuickLinks: React.FC = () => {
  const styles = useStyles();
  const textStyles = useTextStyles();

  const documentationUrl = "https://fundwave.com/guide/reporting/fundwave+functions+for+excel/";
  const recentUpdatesUrl = "https://fundwave.com/guide/reporting/Recent+Updates/";

  return (
    <div className={styles.container}>
      <div className={textStyles.heading2}>Quick links</div>
      <div className={styles.linksList}>
        <a href={documentationUrl} className={textStyles.linkText} target="_blank">
          <DocumentBulletList20Filled />
          <span>Documentation</span>
        </a>
        <a href={recentUpdatesUrl} className={textStyles.linkText} target="_blank">
          <AlertBadge20Filled />
          <span>Recent Updates</span>
        </a>
      </div>
    </div>
  );
};

export default QuickLinks;
